<template>
  <div class="exchange-detail detail-padding">
    <div class="spaceBetween flexEnd">
      <div class="detail-title-1" style="font-size:0.48rem;"><p class="td-word-sm" style="font-size:0.2rem;">Deposit balance</p> <big-number :number.sync="balance"/><span class="td-word-sm" style="font-size:0.2rem;"> TCash</span></div>
      <div class="search-form">
        <search-select @valChange="valChange($event,'type')" label="Type" :options="typeOptions"/>
      </div>
    </div>
    <div class="common-card">
      <el-table
        class="common-table"
        :data="tableList"
        v-loading="loading"
      >
        <el-table-column
          prop="timestamp"
          label="Date"
          align="left"
        >
          <template slot-scope="{ row }">
            {{moment(row.timestamp).format('YYYY.MM.DD')}}
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="Type"
          align="left"
        >
          <template slot-scope="{ row }">
            <div class="spaceLeft">
              <img v-if="row.type == '1'" class="td-type-img" src="@/assets/image/exchange/huan.png"/>
              <img v-if="row.type == '2'" class="td-type-img" src="@/assets/image/exchange/huigou.png"/>
              <img v-if="row.type == '3'" class="td-type-img" src="@/assets/image/exchange/lixi.png"/>
              <div>
                {{getTypeLabel(row.type)}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          label="TCash Quantity"
          align="right"
        >
          <template slot-scope="{ row }">
            <span>{{row.type == '2' ? "-" : "+"}}</span>
            <big-number :number.sync="row.amount"/>
            <span class="td-word-sm">TCash</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total.sync="queryParams.total"
        :page.sync="queryParams.page"
        :limit.sync="queryParams.pageSize"
        @pagination="getList()"
      />
    </div>
  </div>
</template>

<script>
import { depositList } from "@/api/ustn/deposit.js"
export default {
  components: {},
  data() {
    return {
      loading:false,
      searchParams:{},
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
      tableList:[],
      typeOptions:[
        {value:"1",label:"Deposit"},
        {value:"2",label:"Withdraw"},
        {value:"3",label:"Interest"}
      ],
      balance:0,
      contractUSTNFinance:{}
    };
  },
  computed: {},
  methods: {
    async queryDepositBalance() {
      try {
        this.contractUSTNFinance = this.$store.getters.contractMap["contractUSTNFinance"].contract;
        this.contractUSTNFinanceAddress = this.$store.getters.contractMap["contractUSTNFinance"].address;

        this.balance = await this.contractUSTNFinance.methods["queryDepositBalance"]().call({
          from: this.$store.getters.metaMaskObj.account
        });
      } catch (e) {
        console.log(e);
      }
    },
    valChange(data,prop){
      this.searchParams[prop] = data.value;
      this.queryParams = {
        total: 0,
        page: 1,
        pageSize: 10,
      }
      this.getList();
    },
    getTypeLabel(data){
      let item = this.typeOptions.find(i => +i.value == +data);
      return item ? item.label : "";
    },
    getList(){
      this.loading = true;
      depositList({
        account:this.$store.getters.metaMaskObj.account,
        page: this.queryParams.page,
        pageSize: this.queryParams.pageSize,
        ...this.searchParams,
      }).then(res => {
        this.tableList = res.result.data || [];
        this.queryParams.total = res.result.total || 0;
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
    },
    refresh(){
      this.getList();
    }
  },
  created() {
    this.getList();
    this.queryDepositBalance();
  }
};
</script>
<style scoped lang="scss">

.detail-padding {
  padding-left: 10%;
  padding-right: 10%;
}
.common-card {
  // background: #fff;
  border-radius: 0.16rem;
  padding: 0.32rem 0.24rem;
}

// .common-table{
//   /deep/ &.el-table{
//     font-size: 0.16rem;
//     .el-table__header-wrapper th{
//       background-color: #ffffff;
//       color: #AAAAAA;
//       height: 0.4rem;
//       font-size: 0.16rem;
//       font-weight: normal;
//     }
//     th.is-leaf, td{
//       border-bottom:none;
//     }
//     td{
//       font-size: 0.2rem;
//       font-weight: 400;
//       color: #1F1F1F;
//       line-height: 0.24rem;
//     }
//     &::before{
//       background: none;
//     }
//   }

// }
.exchange-detail {
  .flexEnd {
    margin-bottom: 0.24rem;
  }
  .td-type-img{
    width: 0.24rem;
    margin-right:0.16rem;
  }
  // .td-word-sm{
  //   font-size: 0.16rem;
  //   font-family: Roboto-Regular, Roboto;
  //   font-weight: 400;
  //   color: #929DAD;
  //   line-height: 0.19rem;
  // }
}
.search-form{
  justify-content: end;
}
</style>
